import { styled } from "@mui/material/styles";
import { InputBase, Paper } from "@mui/material";
import { MediaQuerys } from "../../../../styles/GlobalStyle";

const { tablet } = MediaQuerys;

export const InputText = styled(InputBase)(() => ({
  width: "100%",
  "& .MuiInputBase-input": {
    fontSize: "14px !important",
    [tablet]: {
      fontSize: "12px !important",
    }
  }
}));

export const InputContainer = styled(Paper)(() => ({
  padding: '2px 4px',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '32px',
  borderRadius: '8px',
  border: '1px solid #e0e0e0',
}));